import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import mapStateToProps from './mapStateToProps';

const RouteWatcher = () => {
    const [open, setOpen] = useState(false);

    const {geoObjRoute} = useSelector(mapStateToProps);

    useEffect(() => {
        if (geoObjRoute && geoObjRoute.data && !geoObjRoute.loading) {
            const {data} = geoObjRoute
            if (!data?.length) setOpen(true);
        }
    }, [geoObjRoute])

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={() => setOpen(false)}
            message="За выбранный период по данному трекеру нет гео-данных"
            action={(<IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setOpen(false)}
            >
                <CloseIcon fontSize="small"/>
            </IconButton>)}
        />
    )
}
export default RouteWatcher